import { AsyncSubject } from 'rxjs';


const segmentsAsyncs: any = {
  details: new AsyncSubject<any>(),
  assignments: new AsyncSubject<any>(),
};

export default segmentsAsyncs;
